// extracted by mini-css-extract-plugin
export default {"Bold":"StandingsCell_Bold__M-Bhi","DefaultCell":"StandingsCell_DefaultCell__tqcAP"};